<template>
    <div class="fixed z-50 pin overflow-auto bg-modal" :class="active ? 'block' : 'hidden'" v-if="emergency">
        <div class="shadow max-w-sm mx-auto mt-24 px-4 md:px-0">
            <div class="rounded bg-white shadow relative" v-if="step == 'errors'">
                <button @click="close" class="text-red-lighter hover:text-red-lightest text-xl absolute pin-t pin-r p-2 m-2">
                    <span class="icon"><i class="mdi mdi-close"></i></span>
                </button>
                <div class="flex items-center justify-center bg-red text-white rounded px-4 py-10 w-full">
                    <span class="icon text-5xl text-white"><i class="mdi mdi-alert-circle"></i></span>
                    <span class="text-sm text-xl ml-4" v-text="errorText ? errorText : $t('an_error_occured')"></span>
                </div>
            </div>
            <div class="rounded bg-white shadow relative" v-if="step == 'deleting'">
                <div class="flex items-center justify-center h-32">
                    <div class="text-center">
                        <span class="icon text-5xl text-grey"><i class="mdi mdi-loading mdi-spin"></i></span><br />
                        <span class="text-sm text-grey-darker mt-4">{{ $t('Loading') }}</span>
                    </div>
                </div>
            </div>
            <div v-if="step == 'details'">
                <div class="bg-white rounded-t p-6">
                    <div class="text-center text-grey-dark leading-normal">
                        {{ $t('Do_you_really_want_to_delete_your_request') }}
                    </div>
                </div>
                <div class="flex border-t items-center">
                    <button @click="close" class="block text-center bg-white rounded-bl w-1/2 border-r py-3 uppercase tracking-wide font-semibold text-sm text-grey-dark hover:text-black">
                        {{ $t('Cancel') }}
                    </button>
                    <button @click="confirm" class="block text-center bg-white rounded-br w-1/2 py-3 uppercase tracking-wide font-semibold text-sm text-grey-dark hover:text-red">
                        {{ $t('Yes_delete') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import firebase from 'firebase/app'
import helpers from '@/mixins/helpers'

import emergencyRepository from '@/data/EmergencyRepository'

export default {
    name: 'delete-emergency-modal',

    props: ['active', 'emergency'],

    mixins: [helpers],

    data () {
        return {
            step: 'details',
            errorText: null
        }
    },

    methods: {
        close () {
            this.$emit('close')

            this.step = 'details'
            this.errorText = null
        },

        changeStep (step) {
            this.step = step
        },

        confirm () {
            this.changeStep('deleting')

            emergencyRepository.delete(this.emergency, () => {
                this.$ga.event({
                    eventCategory: 'Emergencies',
                    eventAction: 'DeleteEmergency'
                })

                setTimeout(() => {
                    this.$emit('deleted')
                }, 1000)
            }, (error) => {
                console.log('error', error)
                this.errorText = error.message
                this.changeStep('errors')
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Patient/DeleteEmergencyModal.vue